"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var Linkify_1 = require("../Linkify");
var mock_1 = require("../../utils/mock");
/**
 * MeetButter Text
 * ---
 * Extended component of Material UI `Typography`,
 * injected with theme.
 */
function MBText(_a) {
    var t = _a.t, _b = _a.tVal, tVal = _b === void 0 ? {} : _b, linkify = _a.linkify, children = _a.children, html = _a.html, _c = _a.namespaces, namespaces = _c === void 0 ? [] : _c, typographyProps = __rest(_a, ["t", "tVal", "linkify", "children", "html", "namespaces"]);
    var tFunc = react_i18next_1.useTranslation(__spreadArray([], __read(namespaces))).t;
    var childrenToRender = react_1.useMemo(function () {
        if (t)
            return tFunc(t, tVal);
        return children;
    }, [t, tFunc, tVal, children]);
    if (html) {
        return (jsx_runtime_1.jsx(StyledTypography, __assign({}, typographyProps, { dangerouslySetInnerHTML: {
                __html: "" + childrenToRender,
            } }), void 0));
    }
    if (linkify) {
        return (jsx_runtime_1.jsx(Linkify_1.Linkify, { children: jsx_runtime_1.jsx(StyledTypography, __assign({}, typographyProps, { children: childrenToRender }), void 0) }, void 0));
    }
    return (jsx_runtime_1.jsx(StyledTypography, __assign({}, typographyProps, { children: childrenToRender }), void 0));
}
exports.MBText = MBText;
var StyledTypography = styled_components_1.default(function (_a) {
    var t = _a.t, tVal = _a.tVal, variant = _a.variant, opacity = _a.opacity, fontWeight = _a.fontWeight, lineHeight = _a.lineHeight, fullWidth = _a.fullWidth, component = _a.component, whiteSpace = _a.whiteSpace, fontStyle = _a.fontStyle, color = _a.color, p = _a.p, pt = _a.pt, pr = _a.pr, pb = _a.pb, pl = _a.pl, px = _a.px, py = _a.py, m = _a.m, mt = _a.mt, mr = _a.mr, mb = _a.mb, ml = _a.ml, mx = _a.mx, my = _a.my, textOverflow = _a.textOverflow, wordBreak = _a.wordBreak, overflow = _a.overflow, textAlign = _a.textAlign, fontSize = _a.fontSize, userSelect = _a.userSelect, highlightColor = _a.highlightColor, props = __rest(_a, ["t", "tVal", "variant", "opacity", "fontWeight", "lineHeight", "fullWidth", "component", "whiteSpace", "fontStyle", "color", "p", "pt", "pr", "pb", "pl", "px", "py", "m", "mt", "mr", "mb", "ml", "mx", "my", "textOverflow", "wordBreak", "overflow", "textAlign", "fontSize", "userSelect", "highlightColor"]);
    var isThereMargin = Boolean(m) ||
        Boolean(mt) ||
        Boolean(mr) ||
        Boolean(mb) ||
        Boolean(ml) ||
        Boolean(mx) ||
        Boolean(my);
    var isTherePadding = Boolean(p) ||
        Boolean(pt) ||
        Boolean(pr) ||
        Boolean(pb) ||
        Boolean(pl) ||
        Boolean(px) ||
        Boolean(py);
    /**
     * if there's NO padding/margin => use `span`
     *
     * if there's padding/margin => use `p`
     */
    var componentToUse = component !== null && component !== void 0 ? component : (isThereMargin || isTherePadding ? 'p' : 'span');
    mock_1.mockFunction({
        t: t,
        tVal: tVal,
        variant: variant,
        opacity: opacity,
        fontWeight: fontWeight,
        fullWidth: fullWidth,
        whiteSpace: whiteSpace,
        lineHeight: lineHeight,
        color: color,
        fontStyle: fontStyle,
        textOverflow: textOverflow,
        overflow: overflow,
        textAlign: textAlign,
        wordBreak: wordBreak,
        fontSize: fontSize,
        userSelect: userSelect,
        highlightColor: highlightColor,
    });
    return jsx_runtime_1.jsx(core_1.Typography, __assign({}, props, { component: componentToUse }), void 0);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n    ", "\n    border-radius: 4px;\n\n    font-family: Inter;\n    a {\n      text-decoration: none;\n      color: #2b6be9;\n    }\n  }\n"], ["\n  && {\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ",
    "\n    ", "\n    ",
    "\n    ", "\n    ", "\n    ", "\n\n    ",
    "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n    ",
    "\n    border-radius: 4px;\n\n    font-family: Inter;\n    a {\n      text-decoration: none;\n      color: #2b6be9;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant ? theme.typography[variant] : '');
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize && "font-size: " + fontSize + "px;";
}, function (_a) {
    var color = _a.color;
    return (color ? "color: " + color + ";" : '');
}, function (_a) {
    var opacity = _a.opacity;
    return (opacity ? "opacity: " + opacity + ";" : '');
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return (fontWeight ? "font-weight: " + fontWeight + ";" : '');
}, function (_a) {
    var fullWidth = _a.fullWidth;
    return (fullWidth ? "width: 100%;" : '');
}, function (_a) {
    var whiteSpace = _a.whiteSpace;
    return (whiteSpace ? "white-space:" + whiteSpace + ";" : '');
}, function (_a) {
    var fontStyle = _a.fontStyle;
    return (fontStyle ? "font-style:" + fontStyle + ";" : '');
}, function (_a) {
    var textTransform = _a.textTransform;
    return textTransform ? "text-transform: " + textTransform + ";" : '';
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return (lineHeight ? "line-height: " + lineHeight + ";" : '');
}, function (_a) {
    var textOverflow = _a.textOverflow;
    return textOverflow ? "text-overflow: " + textOverflow + ";" : '';
}, function (_a) {
    var overflow = _a.overflow;
    return (overflow ? "overflow: " + overflow + ";" : '');
}, function (_a) {
    var textAlign = _a.textAlign;
    return (textAlign ? "text-align: " + textAlign + ";" : '');
}, function (_a) {
    var wordBreak = _a.wordBreak;
    return (wordBreak ? "word-break: " + wordBreak + ";" : '');
}, function (_a) {
    var onClick = _a.onClick, theme = _a.theme;
    return onClick &&
        "\n    cursor: pointer;\n    :hover { background: " + theme.colors.offwhite[200] + "; }\n      ";
}, function (_a) {
    var p = _a.p;
    return p && "padding: " + p * 8 + "px;";
}, function (_a) {
    var pt = _a.pt;
    return pt && "padding-top: " + pt * 8 + "px;";
}, function (_a) {
    var pr = _a.pr;
    return pr && "padding-right: " + pr * 8 + "px;";
}, function (_a) {
    var pb = _a.pb;
    return pb && "padding-bottom: " + pb * 8 + "px;";
}, function (_a) {
    var pl = _a.pl;
    return pl && "padding-left: " + pl * 8 + "px;";
}, function (_a) {
    var px = _a.px;
    return px && "padding-left: " + px * 8 + "px; padding-right:" + px * 8 + "px;";
}, function (_a) {
    var py = _a.py;
    return py && "padding-top: " + py * 8 + "px; padding-bottom:" + py * 8 + "px;";
}, function (_a) {
    var m = _a.m;
    return m && "margin: " + m * 8 + "px;";
}, function (_a) {
    var mt = _a.mt;
    return mt && "margin-top: " + mt * 8 + "px;";
}, function (_a) {
    var mr = _a.mr;
    return mr && "margin-right: " + mr * 8 + "px;";
}, function (_a) {
    var mb = _a.mb;
    return mb && "margin-bottom: " + mb * 8 + "px;";
}, function (_a) {
    var ml = _a.ml;
    return ml && "margin-left: " + ml * 8 + "px;";
}, function (_a) {
    var mx = _a.mx;
    return mx && "margin-left: " + mx * 8 + "px; margin-right:" + mx * 8 + "px;";
}, function (_a) {
    var my = _a.my;
    return my && "margin-top: " + my * 8 + "px; margin-bottom:" + my * 8 + "px;";
}, function (_a) {
    var userSelect = _a.userSelect;
    return userSelect && "user-select: " + userSelect + ";";
}, function (_a) {
    var highlightColor = _a.highlightColor;
    return highlightColor &&
        "\n    background-color: " + highlightColor + ";\n    ";
});
var templateObject_1;
//# sourceMappingURL=MBText.js.map